import { CircularProgress, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { FormikConfig } from 'formik';
import moment from 'moment';
import React from 'react';
import CollapsibleTable from '../../../components/CollapsibleTable/CollapsibleTable';
import FilterComponentV2 from '../../../components/TablegridWithFilters/FilterComponent/FilterComponentv2';
import { aadeKAD } from '../../../lib/fetchers';
import { eliminateOjectNotTruthyValues } from '../../../lib/helperFuncs';
import { aadeKadBranchHeaderTitles, aadeKadBranchSubHeaderTitles, aadeKadFirmHeaderTitles, aadeKadFirmSubHeaderTitles } from '../../../lib/static/details/staticDetails';
import { aadeKadFields } from '../../../lib/static/filters/filterFields';
import { aadeKadIinitialValues } from '../../../lib/static/filters/initialValues';
import { aadeKadValidationSchema } from '../../../lib/static/filters/ValidationSchema';
import Theme from '../../../Themes/main.theme';

const Kad = () => {
  const [data, setData] = React.useState<any>();
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [error, setError] = React.useState<string>();
  const [firmError, setFirmError] = React.useState<string>();
  const [branchError, setBranchError] = React.useState<string>();

  const onSubmit = async (values: FormikConfig<any>) => {
    setIsLoading(true);
    try {
      const response = await aadeKAD(eliminateOjectNotTruthyValues(values));
      response.data.resultKadDesc && setFirmError(response.data.resultKadDesc);
      response.data.resultBrnDesc && setBranchError(response.data.resultBrnDesc);
      setError('');
      const _data = {
        kadFirmRecord: response.data.kadFirmList.kadFirmRecord.map((data: any) => {
          return {
            ...data,
            firmRegistDate: moment(data.firmRegistDate).format('DD-MM-YYYY'),
            firmActStartDate: moment(data.firmActStartDate).format('DD-MM-YYYY'),
            firmActStopDate: moment(data.firmActStopDate).format('DD-MM-YYYY'),
            firmStopDate: moment(data.firmStopDate).format('DD-MM-YYYY'),
          };
        }),
        ...(!response.data.resultBrnDesc
          ? {
            kadBrnRecord: response.data.kadBrnList.kadBrnRecord.map((data: any) => {
              return {
                ...data,
                bacRegistDate: moment(data.bacRegistDate).format('DD-MM-YYYY'),
                bacStartDate: moment(data.bacStartDate).format('DD-MM-YYYY'),
                bacStopDate: moment(data.bacStopDate).format('DD-MM-YYYY'),
                brnStartDate: moment(data.brnStartDate).format('DD-MM-YYYY'),
                brnStopDate: moment(data.brnStopDate).format('DD-MM-YYYY'),
              };
            })}
          :{
            kadBrnRecord: []
          }
        )
      };
      setData(_data);
    } catch (error: any) {
      console.error(error);
      if (error.response.status === 400) {
        setError(error.response.data.message);
      }
    }
    setIsLoading(false);
  };

  return (
    <>
      <Typography sx={{my: 2}} variant='h2'
        color={Theme?.labelColor?.main}> Αναζήτηση Κωδικών Δραστηριότητας Επιχείρησης και 
        Υποκαταστημάτων</Typography>
      <FilterComponentV2
        title='Φίλτρα Αναζήτησης ΚΑΔ'
        validationSchema={aadeKadValidationSchema}
        filterFields={aadeKadFields}
        initialValues={aadeKadIinitialValues}
        resetFilters={true}
        changeFilters={filterValues => onSubmit(filterValues)}
        validateOnBlur={false}
      />
      <Box mt={5}>
        
        {isLoading
          ? <Box sx={{ display: 'flex', justifyContent: 'center'}}>
            <CircularProgress />
          </Box>
          : error
            ? <Typography variant='h4' display='flex'
              justifyContent='center'>
              {error}
            </Typography> 
            : data
              ? <Box display='flex' gap={5}
                flexDirection='column'>
                <Box>
                  {
                    firmError
                      ? <Typography variant='h4' sx={{mb: 1}}>
                        {firmError}
                      </Typography> 
                      : <>
                        <Typography variant='h4' sx={{mb: 1}}>Αποτελεσματα κωδικών και άλλων στοιχείων 
                          δραστηριότητας επιχείρησης</Typography>
                        <CollapsibleTable
                          rows={data.kadFirmRecord}
                          headerTitles={aadeKadFirmHeaderTitles}
                          subHeaderTitles={aadeKadFirmSubHeaderTitles}/>
                      </> 
                  }
                </Box>
                <Box>
                  {
                    branchError
                      ? <Typography variant='h4' sx={{mb: 1}}>
                        {branchError}
                      </Typography>
                      : <>
                        <Typography variant='h4' sx={{mb: 1}}>Αποτελέσματα κωδικών και άλλων στοιχείων 
                          υποκαταστημάτων</Typography>
                        <CollapsibleTable
                          rows={data.kadBrnRecord}
                          headerTitles={aadeKadBranchHeaderTitles}
                          subHeaderTitles={aadeKadBranchSubHeaderTitles}/>
                      </>
                  }
                </Box>
              </Box> 
              : null 
        }
      </Box>
    </>
  );
};

export default Kad;